import styled from "styled-components";

export const StyledRegisterForm = styled.form`
  display: flex;
  justify-content: center;
  height: 90vh;
`;

export const StyledRegisterPage = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 40px;
  width: min(540px, 95vw);
`;

export const StyledRegisterHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
`;

export const StyledRegisterElements = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledInputFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
